import { createFileRoute } from '@tanstack/react-router';
import { RouteComponent } from './-accounts-page';

export const Route = createFileRoute('/_auth/_main-navigation/comptes/')({
  component: RouteComponent,
});
